import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, CircleDashed, CreditCard, Megaphone, MessageCircle, ScrollText, ShoppingBag } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function Changelog() {
  const { t } = useLanguage();
  const versions = [
    { version: 'v1.1', title: t('v11Title'), copy: t('v11Copy'), current: true, icon: CircleDashed },
    { version: 'v1.0', title: t('v10Title'), copy: t('v10Copy'), current: false, icon: CheckCircle2 },
  ];
  const upcoming = [
    { title: t('metaIntegration'), copy: t('metaIntegrationCopy'), icon: Megaphone },
    { title: t('shopifyImport'), copy: t('shopifyImportCopy'), icon: ShoppingBag },
    { title: t('razorpayIntegration'), copy: t('razorpayIntegrationCopy'), icon: CreditCard },
    { title: t('ledgerFeature'), copy: t('ledgerFeatureCopy'), icon: ScrollText },
    { title: t('whatsappAutomation'), copy: t('whatsappAutomationCopy'), icon: MessageCircle },
  ];

  return (
    <div className="mx-auto max-w-[900px] px-4 py-12 sm:px-6 lg:px-8" data-testid="changelog-page">
      <div className="mb-8">
        <div className="mb-2 text-[10px] font-black uppercase tracking-[0.18em] text-orange-600">{t('currentVersion')} v1</div>
        <h1 className="font-heading text-4xl font-black tracking-tight text-slate-900">{t('versionHistory')}</h1>
        <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-500">{t('versionHistoryCopy')}</p>
      </div>

      <div className="space-y-4">
        {versions.map((item) => (
          <section key={item.version} className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
            <div className="flex items-start gap-4">
              <div className={`mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${item.current ? 'bg-orange-50 text-orange-600' : 'bg-emerald-50 text-emerald-600'}`}>
                <item.icon className="h-5 w-5" />
              </div>
              <div>
                <div className="text-xs font-black uppercase tracking-[0.16em] text-slate-400">{item.version}</div>
                <h2 className="mt-1 font-heading text-xl font-black text-slate-900">{item.title}</h2>
                <p className="mt-2 text-sm leading-6 text-slate-600">{item.copy}</p>
              </div>
            </div>
          </section>
        ))}
      </div>

      <section className="mt-8 rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="mb-5">
          <div className="text-[10px] font-black uppercase tracking-[0.18em] text-orange-600">{t('upcoming')}</div>
          <p className="mt-1 text-sm text-slate-500">{t('upcomingCopy')}</p>
        </div>
        <div className="grid gap-3 sm:grid-cols-2">
          {upcoming.map((item) => (
            <div key={item.title} className="rounded-lg border border-slate-200 bg-slate-50 p-4">
              <item.icon className="mb-3 h-5 w-5 text-orange-500" />
              <h3 className="font-heading text-base font-black text-slate-900">{item.title}</h3>
              <p className="mt-1 text-xs leading-5 text-slate-500">{item.copy}</p>
            </div>
          ))}
        </div>
      </section>

      <div className="mt-8 text-sm font-bold">
        <Link to="/" className="text-orange-600 hover:text-orange-700">{t('home')}</Link>
      </div>
    </div>
  );
}
